export const bookingEventsSettings = {
  eventClickActive: {
    admin: {
      month: { item: true, resume: false },
      week: { item: true, resume: false },
      day: { item: true, resume: false }
    },
    manager: {
      month: { item: true, resume: false },
      week: { item: true, resume: false },
      day: { item: true, resume: false }
    },
    advanced: {
      month: { item: true, resume: false },
      week: { item: true, resume: false },
      day: { item: true, resume: false }
    },
    user: {
      month: { item: true, resume: false },
      week: { item: true, resume: false },
      day: { item: true, resume: false }
    }
  },
  cellDoubleClickActive: {
    admin: {
      month: { item: false, resume: false },
      week: { item: true, resume: false },
      day: { item: true, resume: false }
    },
    manager: {
      month: { item: false, resume: false },
      week: { item: true, resume: false },
      day: { item: true, resume: false }
    },
    advanced: {
      month: { item: false, resume: false },
      week: { item: true, resume: false },
      day: { item: true, resume: false }
    },
    user: {
      month: { item: false, resume: false },
      week: { item: true, resume: false },
      day: { item: true, resume: false }
    }
  },
  cellDragActive: {
    admin: {
      month: { item: false, resume: false },
      week: { item: true, resume: false },
      day: { item: true, resume: false }
    },
    manager: {
      month: { item: false, resume: false },
      week: { item: true, resume: false },
      day: { item: true, resume: false }
    },
    advanced: {
      month: { item: false, resume: false },
      week: { item: true, resume: false },
      day: { item: true, resume: false }
    },
    user: {
      month: { item: false, resume: false },
      week: { item: true, resume: false },
      day: { item: true, resume: false }
    }
  },
  showAvailabilitySplit: {
    admin: {
      month: { item: false, resume: false },
      week: { item: true, resume: false },
      day: { item: true, resume: false }
    },
    manager: {
      month: { item: false, resume: false },
      week: { item: true, resume: false },
      day: { item: true, resume: false }
    },
    advanced: {
      month: { item: false, resume: false },
      week: { item: true, resume: false },
      day: { item: true, resume: false }
    },
    user: {
      month: { item: false, resume: false },
      week: { item: true, resume: false },
      day: { item: true, resume: false }
    }
  }
}
